// extracted by mini-css-extract-plugin
module.exports =  {"rating-container":"n9CFJ0x","ratingContainer":"n9CFJ0x","rating":"Rkvf1FN","score":"uUT9NRZ","star":"PqNzep7","count":"lE4Gkle"};